import { Injectable } from '@angular/core';

import { Store } from '@ngxs/store';
import { Observable, forkJoin } from 'rxjs';
import { ObjectsManagerActions } from '../objects-manager/state/actions';
import { Automation as AutomationActions } from '../automations/state/actions';

@Injectable({ providedIn: 'root' })
export class StoreResolver {
  constructor(private readonly store: Store) {}

  resolve(): Observable<any> {
    return forkJoin([
      this.store.dispatch(new ObjectsManagerActions.Get()),
      this.store.dispatch(new AutomationActions.GetEligibleFiles()),
    ]);
  }
}
